module.exports = __webpack_public_path__ + "6c8b6f75a88cfe65c50eda58c2d687b2.webp";